import { Link } from "react-router-dom";

const LivingAreaList = (props) => {
  const items = props.items;

  return (<>
    <div className="row">
      <div className="col-12 text-right">
        <Link to="/realestate/livingarea/new" className="btn btn-primary">+Add</Link>
      </div>
    </div>

    <br />
    <table className="table table-sm">
      <thead>
        <tr>
          <th style={{ width: "40%" }}>FrontYard</th>
          <th>Name</th>
          <th style={{ width: "30%" }}>Weight</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (<LivingAreaListItem key={item.id} item={item} />))}
      </tbody>
    </table>
  </>);
};

const LivingAreaListItem = (props) => {
  const item = props.item;

  return (
    <tr>
      <td>
        <Link to={`/realestate/frontyard/${item.frontYardId}`}>{item.frontYardName}</Link>
      </td>
      <td>
        <Link to={`/realestate/livingarea/${item.id}`}>{item.name}</Link>
      </td>
      <td>{item.weight}</td>
    </tr>
  );
};

export { LivingAreaList };
